import { useNavigate, useLocation } from "react-router-dom";
import { UrlHelper } from "utils/helpers";

function useCreateQuotation() {
  const location = useLocation();
  const navigate = useNavigate();

  return async function onCreateQuotation() {
    navigate(UrlHelper.formatPath(`/Quotation/Create`), {
      state: { background: location, preserveSearch: true },
    });
    return;
  };
}

export default useCreateQuotation;
